<!-- <div class="terms" [formGroup]="termsForm">
    <yara-logo></yara-logo>
    <app-language-chooser> </app-language-chooser>
    <div class="legalBox">
      <div markdown [src]="pathToTerms"></div>
    </div>
    <div>
      <label for="">I accept the terms and conditions</label>
      <input type="checkbox" formControlName="acceptTerms" />
    </div>
</div> -->

<div class="terms" [formGroup]="termsForm">
  <yara-logo></yara-logo>
  <!-- <app-language-chooser> </app-language-chooser> -->
  <app-language-chooser  (languageChange)="changeLanguage($event)" ></app-language-chooser>
  <hr />
  <div markdown id="termsText" [src]="pathToTerms"></div>
  <label i18n="@@acceptterms">I accept the terms and conditions</label>
  <input
    id="acceptTermsCheckbox"
    type="checkbox"
    formControlName="acceptTerms"
  />
</div>
